export const visit = (vm, at) => {
at({ "it": { "upgradePointTooltip": { "upgradePageLink_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, createElement( options, "Link", props, "Esegui l'upgrade" ), " per eseguire questa azione." ); } } } });
};